<template>
  <el-card>
    <div style="display:flex; align-items:center;"> 
      <el-image :src ="logo2" style="height: 50px; "  fit="cover"> </el-image>
    </div>
    <el-divider ></el-divider>
    <div style="display: flex; justify-content: space-between;  ">
      <div style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">{{ fileType }}</span>
      </div>
      <div>
        <el-checkbox @change ="changeLearn" v-if = "fileType != '通知公告' &&  fileType != '办事指南' && fileType != '安全责任书' && basicState"  v-model="learned"  :disabled = "learnBtnCtr"  >已学习</el-checkbox>
        <el-checkbox v-if = "fileType != '通知公告' &&  fileType != '办事指南'"  v-model="basicState" disabled >实验室准入教程</el-checkbox>
      </div>
      
    </div>
    <!-- <div style="font-size: 25px; text-align: center; font-weight: bold; padding: 0;  margin: auto; margin-top: 20px;" > {{ theme }}</div> -->
    <div class = "w-e-text-container">
      <div data-slate-editor style="overflow:auto !important; height: calc(100vh - 320px)" v-html="content">
      </div>
    </div>
    <div style=" display:flex; margin-top: 10px;  padding: 10px" v-if=" funtFootType==3"  >
      <div style="margin-left:100px; width:100px;line-height: 30px; height: 200px; text-align: justify; border-radius: 5px;background-color: antiquewhite;">
         <span style="font-weight: 700;">提示: </span>请按住鼠标左键在蓝色签名区签名,或者手机扫描二维码在手机上签名 
      </div>
      <div style="margin-left:10px">
        <canvas style="background-color: #efd;"  ref="canvas" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing">
        </canvas>
      </div>
      <div id ="qrcode" ref="qrcode" style="width:200px">
      </div>
      <div style=" margin-left:10px ;margin-top: 10px;" >
        <el-button @click="clearCanvas"  type ="danger">清除签名</el-button>
        <el-button @click="saveSignature" type ="primary">保存签名</el-button>
      </div>
    </div>
    <div style=" display:flex; " v-else-if=" funtFootType==2" >
      <div style="margin-left:100px">
        <el-tag size="medium" type = "primary" >您的签名</el-tag>
      </div>
      <div>
        <el-image :src ="fileUrl" fit ="fit" style= "border: 1px solid black; width:700px;height: 150px;"> 
        </el-image>
      </div>
    </div>
    <div style=" display:flex;margin-top: 10px; "  v-else-if=" funtFootType==1 && fileUrl != null && fileUrl != ''" >
      <div style="margin-left:100px">
        <el-tag size="medium" type = "primary" >附件</el-tag>
      </div>
      <div style="margin-left:10px">
        <el-link type="primary" @click = "attachDownLoad" >{{ fileName }}</el-link>
      </div>
    </div>
  </el-card>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import {getToken} from  '@/api/utils'
import axios from  '@/api/axiosConfig'
import logo2 from "@/assets/image/logo2.jpg"
import QRCode from 'qrcodejs2'
import SERVICE_URL  from  '@/api/url'
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
export default {
  name : 'pc_ctr_editor_view',
  data() {
    return {
      logo2,
      funtFootType :'', // 1  文件 /2 图片 / 3 画布
      isDrawing: false, // 是否正在绘制
      context: null, // Canvas上下文
      id :"",
      theme : "",
  
      content:"",
      learnBtnCtr: false,
      learned : false,
      basicState : false,
      fileName:'',
      fileType : "",
      fileUrl :'',
      tokenObj:{
        token :''
      }
    }
  },
  methods : {
     changeLearn(val){
        if(val){
          if(this.fileType=='规章制度'){
            this.markRegLearned()
            return 
          }
          if(this.fileType=='安全知识'){
            this.markKnLearned()
            return 
          }
        }
     },
     markRegLearned (){
      let url = "/bc/exa/reg/regLearn"
      let dat0 = {
        id: this.id
      }
      this.learnBtnCtr = true
      axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) { 

          }else{
            this.learnBtnCtr = false
            this.learned = false
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err)=>{
          this.learned = false
          this.learnBtnCtr = false
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });

     },

     markKnLearned (){
      let url = "/bc/exa/kn/knLearn"
      let dat0 = {
        id: this.id
      }
      this.learnBtnCtr = true
      axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) { 
            
          }else{
            this.learnBtnCtr = false
            this.learned = false
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err)=>{
          this.learned = false
          this.learnBtnCtr = false
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });

     },
     createQRcode( id, text) {
    // 重复创建二维码会，之前的二维码还在，新创建的会被接在下面
    // 此行代码是为了解决以上问题 或者 刷新二维码的时候生成多个二维码的问题
      //if(this.$refs.qrcode) 
     // let long = document.documentElement.clientWidth * (WIDTH / 375)
     try{
      const qrcode =  new QRCode(this.$refs[id], {
        width: 200,
        height: 200,
        text: text,
        correctLevel : QRCode.CorrectLevel.L
      });

     }catch(e){
        this.$message({
          showClose: true,
          message:e,
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return
     }
    },
    attachDownLoad(){
      let that = this
      let outData = {}  //传参数据
      let url = this.fileUrl; //接口
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = "blob";  // 返回类型blob
      xhr.setRequestHeader("Content-type", "application/json;charset=utf-8");
      xhr.setRequestHeader("token", this.tokenObj.token); //这个看后端接口情况决定要不要写
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
          // 请求完成
          if (this.status === 200) {
              // 返回200
              var blob = this.response;
              const a = document.createElement('a');
              const url = window.URL.createObjectURL(blob);
              let reader = new FileReader();
              reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
              reader.onload = function (e) {
                  // 转换完成，创建一个a标签用于下载
                let a = document.createElement('a');
                a.download = that.fileName;
                a.href = e.target.result;
                document.body.appendChild(a);
                // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
              }
          } else {
            that.$message({
              showClose: true,
              message: "下载失败：" + xhr.statusText,
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
      };
      xhr.onerror = function () {
        that.$message({
          showClose: true,
          message: "下载失败：" + xhr.statusText,
          type: 'info',
          duration: MESSAGE_DURATION
        })
      }
      // 发送ajax请求
      xhr.send(JSON.stringify(outData))
    },
    // 鼠标按下时触发
    startDrawing(event) {
      this.isDrawing = true; // 开始绘制
      const { offsetX, offsetY } = event; // 获取鼠标相对于Canvas的偏移量
      this.context.beginPath(); // 开始新的路径
      this.context.moveTo(offsetX, offsetY); // 将路径移动到鼠标位置
    },
    // 当鼠标在 Canvas 上移动时触发
    draw(event) {
      if (!this.isDrawing) return; // 如果没有在绘制中，则返回
      const { offsetX, offsetY } = event; // 获取鼠标相对于Canvas的偏移量
      this.context.lineTo(offsetX, offsetY); // 绘制路径
      this.context.stroke(); // 绘制路径的边框
    },
    // 当鼠标松开时触发，用于停止绘制签名
    stopDrawing() {
      this.isDrawing = false; // 停止绘制
    },
    // 清除
    clearCanvas() {
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      ); // 清除Canvas上的内容
    },
    // 保存
    saveSignature() {
      if( this.isCanvasBlank(this.$refs.canvas) ){
        this.$message({
            showClose: true,
            message:"您未签名！",
            type: 'error',
            duration: MESSAGE_DURATION
          })
         return
       }
      const dataURL = this.$refs.canvas.toDataURL(); // 获取签名图片的Base64编码
      // 在这里可以将dataURL发送到服务器保存，或者进行其他操作
      let file = this.dataURLtoFile(dataURL )
      let url = "/bc/exa/safeBook/signSafeBook"
      let param =  new FormData()
      param.append('safeBookId',this.id)
      param.append('file',file)
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          // 'token': this.tokenObj.token
        }
      }).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '签名成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    isCanvasBlank(canvas) {
      var blank = document.createElement('canvas');//系统获取一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL();//比较值相等则为空
    },
    dataURLtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    // 加载一个通知公告
    noticeOneLoad(id){
      let url = "/bc/exa/notice/getNoticeInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个安全知识
    knOneLoad(id){
      let url = "/bc/exa/kn/getKnLearnInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            
            this.learned = response.data.data.learned > 0
            if(this.learned){
              this.learnBtnCtr = true
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个规章制度
    regOneLoad(id){
      let url = "/bc/exa/reg/getLearnRegInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            this.learned = response.data.data.learned > 0
            if(this.learned){
              this.learnBtnCtr = true
            }
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个办事指南
    guidOneLoad(id){
      let url = "/bc/exa/guid/getGuidInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },

    safeBookOneLoad(id){
      let url = "/bc/exa/safeBook/getSafeBookInfo"
      let dat0 = {
        id: id,
        student:true
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            this.learned = response.data.data.learned >0
            if(this.learned){
              this.learnBtnCtr = true
            }
            let fileTreeId = response.data.data.fileTreeId
            if(fileTreeId != null && fileTreeId != '' ){
              this.funtFootType = 2
              this.fileUrl = response.data.data.signImage
            }else{
              this.funtFootType = 3
              setTimeout(()=>{
                this.context = this.$refs.canvas.getContext("2d"); // 获取Canvas上下文
                this.$refs.canvas.width = 700; // 设置Canvas的宽度
                this.$refs.canvas.height = 200; // 设置Canvas的高
              },200)
              let qrText = response.data.data.qrText
              if(qrText != null && qrText!= ''){

                setTimeout(()=>{ this.createQRcode( `qrcode`, SERVICE_URL +"/#" + qrText);},200)
              }
              
             
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    }
  },
  created () {
    setTimeout(()=>{getToken(this.tokenObj)},200)
    this.id = this.$route.params.id
    this.fileType =  this.$route.query.fileType
    switch(this.fileType) {
      case fileType.NOTICE_FILE:
          this.noticeOneLoad(this.id)
          break
      case fileType.SAFE_KNOWLEDGE:
          this.knOneLoad(this.id)
          break   
      case fileType.REGULATIONS.NAME:
          this.regOneLoad(this.id)
          break   
      case fileType.WORK_GUID:
        this.guidOneLoad(this.id)
        break   
      case fileType.SAFE_BOOK:
        this.safeBookOneLoad(this.id)
        break  
    }
  },
  mounted() {
   
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 1px 0;
  width: 100%
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_editor_view.vue